import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Configuration } from '../../constants/config';

/*
  Generated class for the PaymentServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PaymentServiceProvider {

    private ServerWithApiUrl: string;

    constructor(public http: Http, _configuration: Configuration) {
        this.ServerWithApiUrl = _configuration.ServerWithApiUrl;
    }

    /**
     * @Info Make payment
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    payment(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Payment/checkOut', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    let dataStr = "RESPONSE: "+JSON.stringify(error);
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred", ErrorList: [dataStr]});
                });


        });
    }

}



// WEBPACK FOOTER //
// ./src/providers/payment-service/payment-service.ts